import { render, staticRenderFns } from "./Outbound.vue?vue&type=template&id=06ac074c&scoped=true&"
import script from "./Outbound.vue?vue&type=script&lang=js&"
export * from "./Outbound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ac074c",
  null
  
)

export default component.exports